define(function (require) {

    window.lpTag = window.lpTag || {};

    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var lpAgent = require('web-agent-assets-js/lpAgent');
    var agentLEManager = require('web-agent-utils/agentLEManager');

    lpTag.lpAgentController = function (model) {

        var agentController = {applicationType: "lpAgentController"};

        var agentModel = model;

        var ringingCount;

        var logger = WebAgentLogger.getLogger(agentController.applicationType);

        agentController.getModelParam = function (paramName) {
            return agentModel.get(paramName);
        };

        agentController.bindModelParam = function (modelParam, func, scope, trigger, deepBind) {
            agentModel.bind(modelParam, func, scope, trigger, deepBind);
        };

        agentController.unbindModelParam = function (key, callback, context) {
            agentModel.unbind(key, callback, context);
        };

        // Decorator Methods
        agentController.logInAgent = function (object) {
            object.webAgent = agentLEManager.isInLE() ? "LE-" + agentLEManager.versionLE() : this.translate("version");
            logger.info("", "logInAgent", object);
            return lpAgent.agent.logInAgent(object);
        };
        agentController.logOutAgent = function (object) {
            logger.info("", "logOutAgent", object);
            return lpAgent.agent.logOutAgent(object);
        };
        agentController.getAgentInfo = function (object) {
            logger.info("", "getAgentInfo", object);
            return lpAgent.agent.getAgentInfo(object);
        };
        agentController.getAvailability = function () {
            logger.info("", "getAvailability");
            return lpAgent.agent.getAvailability();
        };
        agentController.setAvailability = function (object) {
            logger.info("", "setAvailability", object);
            return lpAgent.agent.setAvailability(object);
        };
        agentController.getAvailableAgents = function (object) {
            logger.info("agent requests for available agents", "getAvailableAgents");
            return lpAgent.agent.getAvailableAgents(object);
        };
        agentController.acceptChat = function (object) {
            logger.info("agent accepts a chat", "acceptChat");
            return lpAgent.agent.acceptChat(object);
        };

        agentController.initSession = function (dataObj) {
            logger.info("", "initSession", dataObj);
            //Added this because it crashes application otherwise
            if (!dataObj.accessToken) {
                dataObj.appKey = agentController.getModelParam("appKey");
            }
            dataObj.domain = agentController.getModelParam("domain");
            dataObj.lpNumber = dataObj.account;
            return lpAgent.agent.init(dataObj);
        };

        agentController.getSessionData = function (data) {
            if (lpTag.WebAgent.WebAgentSessionStorage) {
                return lpTag.WebAgent.WebAgentSessionStorage.getSessionData(agentController.applicationType + '_' + data.name, data.key);
            }
        };

        agentController.saveSessionData = function (data) {
            if (lpTag.WebAgent.WebAgentSessionStorage) {
                lpTag.WebAgent.WebAgentSessionStorage.setSessionData(agentController.applicationType + '_' + data.name, data.key, data.value);
            }
        };

        agentController.removeSessionData = function (data) {
            if (lpTag.WebAgent.WebAgentSessionStorage) {
                lpTag.WebAgent.WebAgentSessionStorage.removeSessionData(agentController.applicationType + '_' + data.name, data.key);
            }
        };

        function init(){
            if(lpAgent.agent){
                // Register on agent callbacks
                for (var key in lpAgent.agent) {
                    if(lpAgent.agent.hasOwnProperty(key)){
                        if (String(key).indexOf('on') === 0) {
                            switch (key) {
                                case "onIncomingRequests": lpAgent.agent.onIncomingRequests(handleIncomingRequests); break;
                                case "onAcceptChat": lpAgent.agent.onAcceptChat(handleAcceptChat); break;
                                case "onAvailableAgents" : lpAgent.agent.onAvailableAgents(handleAvailableAgents); break;
                                case "onLogInAgent": lpAgent.agent.onLogInAgent(handleLogIn); break;
                                case "onLogOutAgent" : lpAgent.agent.onLogOutAgent(handleLogOut); break;
                                case "onAgentInfo": lpAgent.agent.onAgentInfo(handleAgentInfo); break;
                                case "onPreDefinedContent": lpAgent.agent.onPreDefinedContent(handlePreDefinedContent); break;
                                case "onSetAvailability": lpAgent.agent.onSetAvailability(handleSetAvailability); break;
                                case "onAgentResumed" : lpAgent.agent.onAgentResumed(handleAgentResumed); break;
                                case "onChatsResumed" : lpAgent.agent.onChatsResumed(handleChatsResumed); break;
                                case "onLog" : lpAgent.agent.onLog(handleOnLog); break;
                                case "onLoad" : break;
                                default : lpAgent.agent[key](updateModel);
                            }
                        }
                    }
                }
                agentController.participantsCounter = 0;
            } else {
                setTimeout(init, 500);
            }
        }

        function handleLogIn(data) {
            if (!data.error) {
                logger.info("", "handleLogIn", data);
                agentModel.set("application.status", data.status);
                updateModel(data);
                lpAgent.agent.getAgentInfo({
                    success: function (agentInfo) {
                        if (!agentInfo.error) {
                            if (agentLEManager.isFirstTimeLELogin()) {
                                lpAgent.agent.setAvailability({chatAvailability: "Online"});
                            }
                            if (!lpTag.WebAgent.logicController.useCannedResponsesACService()) {
                                lpAgent.agent.getPreDefinedContent();
                            }
                        }
                    }
                });
            } else {
                logger.error("", "handleLogIn", data);
                logger.graph({name: 'loginError'});
                handleLogOut(data);
                updateModel(data);
            }
        }

        function handleLogOut(data) {
            if (data.error) {
                logger.error("", "handleLogOut", data);
                logger.graph({name: 'logoutError'});
                agentModel.set("application", data); // doing a "set" here to make sure that the the existence and value of statusId and errorMessage will be of this specific trigger and not of previous ones.
            } else {
                logger.info("", "handleLogOut", data);
                agentModel.modify("application", data);
            }
        }

        function updateModel(data) {
            agentModel.modify("agent", data);
        }

        function handleIncomingRequests(data) {
            if (data.error) {
                logger.error("", "handleIncomingRequests", data);
            } else {
                if (ringingCount !== data.ringingCount) {
                    logger.info("ringing count has changed from " + (ringingCount || 0) + " to " + data.ringingCount, "handleIncomingRequests");
                    ringingCount = data.ringingCount;
                }
                logger.debug("", "handleIncomingRequests", data);
                agentModel.set("agent.ringingCount", data.ringingCount);
            }
        }

        function addChatToModel(data) {
            agentModel.modify("chats." + data.chatInfo.chatId, data, '@id');
        }

        function addParticipantToModel(chatData) {
            var visitorObject = {
                participantInfo: chatData.visitorInfo,
                chats: {}
            };
            var participantPath = lpTag.WebAgent.logicController.getParticipantPath(chatData.visitorInfo.visitorId);
            if (agentController.getModelParam(participantPath + '.participantInfo.spectatedEngagement') ||
                agentController.getModelParam(participantPath + '.participantTag') === null) {
                visitorObject.participantTag = '';
            }
            visitorObject.chats[chatData.chatInfo.chatId] = chatData.chatInfo.chatId;
            // reset auth data related in the model in order to properly handle split sessions
            // between auth an non auth chats
            agentModel.removeKey(participantPath + '.participantInfo.participantId');
            agentModel.removeKey('participants.info.' + chatData.visitorInfo.visitorId + '.data.participant.isAuthenticated');

            agentModel.modify(participantPath, visitorObject);
        }

        function handleAcceptChat(data) {
            if (data.error) {
                logger.error("", "handleAcceptChat", data.visitorInfo);
                logger.graph({name: 'acceptChatError'});
            } else {
                var logData = {visitorInfo : data.visitorInfo, chatInfo : {chatId: data.chatInfo.chatId, lastUpdate: data.chatInfo.lastUpdate, startTime: data.chatInfo.startTime, state: data.chatInfo.state, chatSessionId: data.chatInfo.chatSessionId}};
                logger.info("", "handleAcceptChat", logData);
                handleNewVisitor(data);
                addChatToModel(data);
                addParticipantToModel(data);
                agentLEManager.triggerLEEvent("webAgent:hasVisitors");
            }
            data = null;
        }

        function handleNewVisitor(data) {
            if (data.visitorInfo && data.visitorInfo.visitorId) {
                var participantPath = lpTag.WebAgent.logicController.getParticipantPath(data.visitorInfo.visitorId);
                if (agentController.getModelParam(participantPath + '.participantInfo.visitorSerialNumber') === null) {
                    //Checking if the visitor is new or if he was open for spectate
                    agentController.participantsCounter++;
                    data.visitorInfo.visitorSerialNumber = agentController.participantsCounter;
                    data.visitorInfo.engagementStartTime = data.chatInfo.startTime;
                }
                // setting the accepted/spectated flags so that the listeners will be called for every new chat
                data.visitorInfo.acceptedEngagement = true;
                data.visitorInfo.spectatedEngagement = false;
            }
        }

        function handleAvailableAgents(data) {
            if (data.error) {
                logger.error("", "handleAvailableAgents", data);
                logger.graph({name: 'getAvailableAgentsError'});
            } else {
                logger.info("list of available agents received from the server", "handleAvailableAgents");
                agentModel.modify("agent.availableAgents", data, "@id");
            }
        }

        // Consider moving the model data formatting from here to the lpAMSAgentStatusController
        function handleAgentInfo(data) {
            if (data.error) {
                logger.error("", "handleAgentInfo", data);
            } else {
                logger.debug("", "handleAgentInfo", data);
                if (typeof(data.acd) === "undefined") {
                    agentModel.removeKey("agent.acd");
                }

                //In case of blended, when the maxChats (for RT chats) is 0, we want to still allow the agent to be online.
                if (+data.maxChats === 0) { //if the maxChats is 0 (no chats)
                    if (lpTag.WebAgent.logicController.hasMessagingFeature()) { //if we're in async
                        data.chatAvailability = agentModel.get('agent.chatAvailability'); //set it to whatever it needs to be
                    }
                }
                // In status case change arrived from the server
                if (agentModel.get('agent.chatAvailability') !== data.chatAvailability && data.chatAvailability === "Away") {
                    agentModel.set("agent.isChatAvailabilityByServer", true);
                }
                agentModel.modify("agent", data, "id");
            }
        }

        function handlePreDefinedContent(data) {
            if (data.error) {
                logger.error("", "handlePreDefinedContent", data);
            } else {
                // Add categoryId to data for predefined content filtering and set the skillId to array is string
                if (data.preDefinedContent) {
                    for (var i = 0; i < data.preDefinedContent.length; i++) {
                        data.preDefinedContent[i].categoryId = i;
                        if (!data.preDefinedContent[i].skills) {
                            data.preDefinedContent[i].skills = {skillId: []};
                        } else if (typeof (data.preDefinedContent[i].skills.skillId) === "string") {
                            data.preDefinedContent[i].skills.skillId = [data.preDefinedContent[i].skills.skillId];
                        }
                    }
                }
                logger.info("pre-defined content list received from the server", "handlePreDefinedContent");
                agentModel.set("preDefinedContent", data.preDefinedContent);
            }
        }

        function handleSetAvailability(data) {
            if (data.error) {
                logger.error("", "handleSetAvailability", data);
                logger.graph({name: 'setAvailabilityError'});
            } else {
                logger.info("", "handleSetAvailability", data);
                handleAvailabilityReasonId(data);
                updateModel(data);
            }
        }

        function handleAvailabilityReasonId(data) {
            if(data && !data.chatReasonId) { //if no reasonId was chosen there are 2 choices (undefined=no reason, null="Other" reason)
                if(data.chatReasonId === null) {
                    data.chatReasonId = -1;
                }
                else { //undefined
                    agentModel.removeKey("agent.chatReasonId", data);
                }
            }
        }

        function handleAgentResumed (data) {
            if (data.error) {
                logger.error("", "handleChatsResumed", data);
            } else {
                logger.info("", "handleChatsResumed", data);
                updateModel(data);
            }
        }

        function handleChatsResumed(data) {
            if (data.error) {
                logger.error("", "handleChatsResumed", data);
            } else {
                logger.info("", "handleChatsResumed", data);
                updateModel(data);
            }
        }

        function handleOnLog(data) {
            if (logger) {
                var type = data.type;
                var errorMessage = {};
                for (var key in data) {
                    if (data.hasOwnProperty(key) && data[key] !== data) {
                        if (typeof data[key] === 'object') {
                            try {
                                errorMessage[key] = JSON.stringify(data[key]);
                            } catch (err) {
                                errorMessage[key] = key + "-recursive object";
                            }
                        } else if (typeof data[key] === 'function') {
                            errorMessage[key] = 'func:' + key;
                        } else {
                            errorMessage[key] = data[key];
                        }
                    }
                }
                try {
                    errorMessage = JSON.stringify(errorMessage);
                } catch (err) {
                    errorMessage = "data in log is recursive";
                }
                logger[type.toLowerCase()](errorMessage, 'onLog');
            }
        }

        init();
        return agentController;
    };

    return lpTag.lpAgentController;

});
